const BaseView = require('components-framework/view/base.view');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');
const tracking = require('od-modules/checkin/tracking');

const HIDDEN_CLASS = 'odf-hidden';

module.exports = withCachedSelectors(BaseView.extend({

    selectors: {
        checkinStatusContainer: '.checkin_status_container',
    },

    initialize() {
        this.initializeLandingPageUrl();
        this.el.innerHTML = this.templates.main(this);
    },

    showCheckinStatus(show) {
        this.$el.find(this.selectors.checkinStatusContainer).toggleClass(HIDDEN_CLASS, !show);
        if (show) {
            const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
            tracking.trackAutoCheckinOk(bookingInfo);
        }
    },

    initializeLandingPageUrl() {
        const defaultLandingPageUrl = {
            ED: 'https://www.edreams.com/app/',
            OP: 'https://www.opodo.com/mobile-app/',
            GV: 'https://www.govoyages.com/application-voyage/',
            TL: 'https://www.travellink.com/app/',
        };

        if (!this.keys.appDownloadLandingPageURL) {
            this.keys.appDownloadLandingPageURL = defaultLandingPageUrl[Odigeo.SessionScope.brand];
        }
    },

}));
